export const FETCH_HOME_PROMO_STARTED = `FETCH_HOME_PROMO_STARTED`;
export const FETCH_HOME_PROMO_SUCCESS = `FETCH_HOME_PROMO_SUCCESS`;
export const FETCH_HOME_PROMO_FAILURE = `FETCH_HOME_PROMO_FAILURE`;
export const FETCH_HOME_PROMO_NOT_FOUND = `FETCH_HOME_PROMO_NOT_FOUND`;
